import './App.css';

import Navigation from './sections/Navigation/Navigation';

import Home from './views/Home/Home';
import Menu from './views/Menu/Menu';
import About from './views/About/About';
import PageNotFound from './views/PageNotFound/PageNotFound';
import Reviews from './views/Reviews/Reviews';
import ContactUs from './views/ContactUs/ContactUs';

import AdminAccess from './views/AdminAccess/AdminAccess';
import ScrollToTopOnRouteChange from './ScrollToTopOnRouteChange';

import { Routes, Route, useLocation } from 'react-router';
import CopyrightFooter from './sections/CopyrightFooter/CopyrightFooter';
import OrderNow from './sections/OrderNow/OrderNow';

function App() {
  const location = useLocation();

  const AllRoutes = [
    { path: '/', element: <Home /> },
    { path: '/menu', element: <Menu /> },
    { path: '/about', element: <About /> },
    { path: '/reviews', element: <Reviews /> },
    { path: '/contact_us', element: <ContactUs /> },
    { path: '/contact', element: <ContactUs /> },
    { path: '/contactus', element: <ContactUs /> },
    { path: '/admin', element: <AdminAccess /> },
    { path: '*', element: <PageNotFound /> },
  ];
  return (
    <div className="App">
      {location.pathname !== '/admin' && <Navigation />}
      <ScrollToTopOnRouteChange />

      <Routes>
        {AllRoutes.map((route, index) => (
          <Route path={route.path} element={route.element} key={index} />
        ))}{' '}
        ;
      </Routes>

      {location.pathname !== '/admin' && <CopyrightFooter />}

      <OrderNow />
    </div>
  );
}

export default App;
